import React from "react";
import { TKIconAdd } from "assets/images/svgs";
import ProjectCard from "./components/ProjectCard";
import DashboardCard from "shared/DashboardCard";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const Details = () => {
  const navigate = useNavigate();
  const handleProjectNavigate = () => {
    let path = "/ngo/projects";
    navigate(path);
  };

  const { projects, completedProjectsCount } = useSelector(
    (state) => state.project
  );
  const { totalDonationAmount } = useSelector((state) => state.donation);

  return (
    <div>
      <div className="flex flex-col gap-y-6">
        <div className="flex max-[470px]:flex-wrap">
          <DashboardCard
            className="rounded-l-lg"
            title="Total Donations"
            amount={totalDonationAmount}
            paragraph="since January"
            textColor="text-white"
            paragraphColor="text-[#F0CA18]"
            bgColor="bg-[#011F56]"
            percentage="+0%"
          />
          <DashboardCard
            title="Completed Projects"
            completedProjects={completedProjectsCount}
            paragraph="since January"
            paragraphColor="#0ABD06"
            bgColor="bg-white"
            percentage="0"
          />
        </div>
        <div className="p-6 bg-white rounded-md gap-3 flex flex-col">
          <div className="flex justify-between">
            <p className="font-semibold text-[16px]">Active Projects</p>
            {projects?.length > 0 && (
              <p
                onClick={handleProjectNavigate}
                className="text-[#F57200] text-[14px] cursor-pointer underline transition-all duration-300 hover:text-[15px]"
              >
                View all
              </p>
            )}
          </div>
          {projects?.length > 0 ? (
            <div className="w-full flex justify-start items-center gap-x-2 overflow-x-scroll">
              {projects?.map((project, index) => (
                <ProjectCard
                  key={index}
                  title={project.name}
                  text={project.projected_impact}
                  imageUrl={project.project_picture}
                />
              ))}
            </div>
          ) : (
            <div className=" h-[230px] flex justify-center items-center">
              <Link to="/ngo/projects/create-project">
                <div className="flex flex-col gap-2 justify-center items-center">
                  <div className="w-[90px] h-[90px] rounded-full border-dashed border-[#213874] border flex justify-center items-center">
                    <TKIconAdd />
                  </div>
                  <p className="text-[#7A7A7A]">
                    No active project. Create a project
                  </p>
                </div>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Details;
